import { urlEscaped } from '@app/utils/urlEscaped'

import { createApiAction } from '@app/packages/api/utils'
import type { ApiRegion } from '@app/packages/api/v2/types/entities'
import { v2Path } from '@app/packages/api/v2/utils'

export const getRegions = () =>
  createApiAction('getRegions', dispatch => dispatch<{ data: ApiRegion[] }>({ method: 'GET', endpoint: v2Path('/api/v2/regions', { filter: 'all' }) }))

export const getRegionsById = (id: string) =>
  createApiAction('getRegionsById', dispatch => dispatch<{ data: ApiRegion }>({ method: 'GET', endpoint: urlEscaped`/api/v2/regions/${id}` }))
